import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import Landing from './pages/Landing';
import Inscription from './pages/Inscription';
import Connexion from './pages/Connexion';
import Activation from './pages/Activation';
import VerificationOTP from './pages/VerificationOTP';
import DashboardClient from './pages/DashboardClient';
import DashboardAdmin from './pages/DashboardAdmin';
import ForgotPassword from './pages/ForgotPassword';
// Public pages
import Comptes from './pages/public/Comptes';
import CartesPublic from './pages/public/Cartes';
import Credits from './pages/public/Credits';
import Assurances from './pages/public/Assurances';
import Bourse from './pages/public/Bourse';
import Devises from './pages/public/Devises';
import Aide from './pages/public/Aide';
import APropos from './pages/public/APropos';
import Professionnels from './pages/public/Professionnels';
import { MentionsLegales, CGU, Confidentialite, CookiesPage, RGPD, PlanDuSite } from './pages/public/Legal';
import { getSession } from './lib/api';
import PageTitle from './components/PageTitle';
import { ThemeProvider } from './lib/ThemeContext';
import { LanguageProvider } from './lib/LanguageContext';
import './App.css';

function RequireClient({ children }) {
  const { token, user } = getSession();
  if (!token || !user || user.role !== 'client') return <Navigate to="/connexion" replace />;
  return children;
}
function RequireAdmin({ children }) {
  const { token, user } = getSession();
  if (!token || !user || user.role !== 'admin') return <Navigate to="/connexion" replace />;
  return children;
}

function App() {
  return (
    <LanguageProvider>
    <ThemeProvider>
      <BrowserRouter>
        <PageTitle />
        <Toaster position="top-right" richColors closeButton />
        <Routes>
          <Route path="/" element={<Landing />} />
          {/* Public marketing pages */}
          <Route path="/comptes" element={<Comptes />} />
          <Route path="/cartes" element={<CartesPublic />} />
          <Route path="/credits" element={<Credits />} />
          <Route path="/assurances" element={<Assurances />} />
          <Route path="/bourse" element={<Bourse />} />
          <Route path="/devises" element={<Devises />} />
          <Route path="/aide" element={<Aide />} />
          <Route path="/a-propos" element={<APropos />} />
          <Route path="/professionnels" element={<Professionnels />} />
          {/* Legal */}
          <Route path="/mentions-legales" element={<MentionsLegales />} />
          <Route path="/cgu" element={<CGU />} />
          <Route path="/confidentialite" element={<Confidentialite />} />
          <Route path="/cookies" element={<CookiesPage />} />
          <Route path="/rgpd" element={<RGPD />} />
          <Route path="/plan-du-site" element={<PlanDuSite />} />
          {/* Auth */}
          <Route path="/inscription" element={<Inscription />} />
          <Route path="/connexion" element={<Connexion />} />
          <Route path="/activation" element={<Activation />} />
          <Route path="/verification-otp" element={<VerificationOTP />} />
          <Route path="/mot-de-passe-oublie" element={<ForgotPassword />} />
          {/* Apps */}
          <Route path="/dashboard/*" element={<RequireClient><DashboardClient /></RequireClient>} />
          <Route path="/admin/*" element={<RequireAdmin><DashboardAdmin /></RequireAdmin>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
    </LanguageProvider>
  );
}

export default App;
